import {memo} from 'react'
import {useSelector} from 'react-redux'
import {SimpleBlueButton} from '../../components/core/button'
import CustomSelect from '../../components/core/customSelect'
import TeamSwitcher from '../../components/pages/teams'
import {useNamespaceTranslations} from '../../utils/hooks/useNamespacesTranslations'

const FilterLogGroup = ({
    onApply,
    onClear,
    logGroupOptions,
    filters,
    onServiceChange,
    onLogGroupChange
}) => {
    const services = useSelector((state) => state.resources.services)
    const text = useNamespaceTranslations('log-management')

    return (
        <>
            <div className="log-scope-filters">
                <TeamSwitcher containerClassName="teams" />
                <CustomSelect
                    name="service"
                    value={filters.service}
                    options={services}
                    placeholder={text.service}
                    infoText={text.service_info}
                    onChange={(_, value) => onServiceChange(value)}
                />
                <CustomSelect
                    name="log_group_id"
                    isMulti
                    showLabel
                    showSelectedOptions
                    value={filters.log_group}
                    options={logGroupOptions}
                    placeholder={text.log_group}
                    infoText={text.log_group_info}
                    onChange={(_, value) => onLogGroupChange(value)}
                />
            </div>
            <div className="apply-filter">
                <SimpleBlueButton className="cancel-button" onClick={onClear}>
                    {text.clear}
                </SimpleBlueButton>
                <SimpleBlueButton onClick={onApply}>
                    {text.apply}
                </SimpleBlueButton>
            </div>
        </>
    )
}

export default memo(FilterLogGroup)
